import { useState } from "react";
import { Get, Set } from "../../../../../Request";

export const useEditTimeTable = (app) => {
  const [data, setData] = useState({});
  const [form, setForm] = useState({ mobile: "" });
  const [loading, setloading] = useState({
    slug: true,
  });
  const [newData, setNewData] = useState();

  const [modal, setModal] = useState({ visible: false });
  const isInArray = (timekey, dayname) => {
    let res = false;
    form.times &&
      form.times.map(element => {
        if (element.timekey == timekey && element.dayname == dayname) {
          res = true;
        }
      });
    return res;
  };
  const removeTime = (timekey, dayname) => {
    setForm({
      ...form,
      times: [...form.times].filter(
        element => !(element.timekey == timekey && element.dayname == dayname)
      ),
    });
  };
  const addTime = (timekey, dayname) => {
    setForm({ ...form, times: [...form.times, { timekey, dayname }] });
  };
  const toggleSelect = (timekey, dayname) => {
    if (isInArray(timekey, dayname)) {
      removeTime(timekey, dayname);
    } else {
      addTime(timekey, dayname);
    }
  };
  const arrLength = () => {
    return form.times.length;
  };
  const getSingle = async (item_id, date) => {
    setloading({ slug: true });
    await Get({
      url: "/timetable/show_admin_and_manger",
      data: {
        item_id,
        date,
        app
      },
    }).then(data => {
      setData(data);

      if (data.showmodel == "list") {
        setNewData({ ...newData, child: data?.times[0]?.child })
      }
      else if (data.showmodel == "table") {
        setNewData({
          ...newData,
          buyballprice: data?.times?.Friday?.times[0]?.buyballprice,
          ballprice: data?.times?.Friday?.times[0]?.ballprice
        })
      }

      setloading({ slug: false });
    });
  };
  const updateTimeTable = async data => {
    setloading({ ...loading, update: true });

    await Set({
      url: "/item/update_timetable",
      data: { ...data },
    }).then(() => {
      // setModal({ ...data, visible: false });
      setloading({ ...loading, update: false });
    });
  };
  const checkMobile = async (modal, setModal) => {
    setloading({ btn: true });
    await Get({ url: "/manager/check_user", data: form }).then(response => {
      setloading({ btn: false });
      if (response.user) {
        setModal({ ...modal, step: "reserve", ...response });
      } else {
        setModal({ ...modal, step: "newuser" });
      }
      setForm({ ...form, ...response });
    });
  };
  const reserve = async (data, setModal) => {
    setloading({ reserve: true });

    await Set({
      url: "/manager/buy_foruser",
      data: data,
    }).then(response => {
      setForm({ mobile: "" });
      setloading({ reserve: false });
      setModal({ ...data, visible: false });
    });
  };
  const renderState = data => {
    if (data && data != "false" && data.length !== 10) {
      return false;
    } else {
      if (data && data.length === 10) {
        return true;
      } else {
        return false;
      }
    }
  };
  return {
    data,
    loading,
    getSingle,
    modal,
    setModal,
    updateTimeTable,
    form,
    setForm,
    checkMobile,
    reserve,
    renderState,
    toggleSelect,
    arrLength,
    isInArray,
    newData,
    setNewData
  };
};
